module.exports = __webpack_public_path__ + "static/img/address.b45a14b0.png";